import React, {useEffect, useState} from 'react';
import {apisStore} from "../../../context/GlobalStates";
import {DEFAULT_OPTIONS} from "../../../service/HttpService";
import {getPage} from "../AppHeader/AppHeader";
import type {AxiosResponse, RawAxiosRequestConfig} from "axios";

const ServerInfo = () => {

    const [content, setContent] = useState<String | null>(null)
    const [humanReadableTimestamp, setHumanReadableTimestamp] = useState<String | null>(null)

    let apiStore = apisStore.getState();

    let versionInfo: Promise<AxiosResponse<any>>;

    switch (getPage()) {
        case "data_writer":
            versionInfo = apiStore.dataPusher.versionApi.getVersionInfo(DEFAULT_OPTIONS)
            break;
        case "job_runner":
            versionInfo = apiStore.jobRunner.versionApiJR.getVersionInfo(DEFAULT_OPTIONS)
            break;
        default:
            versionInfo = apiStore.dataCollector.versionApiDC.getVersionInfo(DEFAULT_OPTIONS)
            break;
    }

    useEffect(() => {
        versionInfo
            .then(v => v.data)
            .then(data => {
                setContent(JSON.stringify(data, null, 2));
                setHumanReadableTimestamp(new Date(data.buildTime).toISOString());
            })
            .catch(e => setContent("Error fetching version info: " + e.message))
    }, [])

    return (
        <div className={"flex flex-column gap-2"}>
           <span> Build timestamp: {humanReadableTimestamp}</span>
            <pre>
                {content}
            </pre>
        </div>
    );
};

export default ServerInfo;